enum ProfileFieldType {
    City = 'City',
    State = 'State',
    Zip = 'Zip',
    FirstName = 'FirstName',
    LastName = 'LastName',
    PhoneNumber = 'PhoneNumber',
    Address1 = 'Address1',
    Address2 = 'Address2',
    Custom = 'Custom',
    CountryCode = 'CountryCode',
    FullAddress = 'FullAddress',
}

export default ProfileFieldType;
